module.exports = __webpack_public_path__ + "img/business_receive_03.310bf615.png";